import { createSelector } from 'reselect'

export const getEquipmentDependencies = createSelector(
  (state) => state && state.ads && state.ads.equipment && state.ads.equipment.dependencies
    ? state.ads.equipment.dependencies : {},
  (equipmentDependencies) => equipmentDependencies
)
